export const DRAGGING_CLASS_NAME = 'prosekit-dragging'
